import { ui } from '@procuros/datachecks';
import { CellContext } from '@tanstack/react-table';

import { logError } from 'services/logging/logging';
import { GenericError } from 'support/helpers/errors/errors';
import { cellMapping } from 'components/DataTable/cellMapping';
import { DisplayModes, WebEDIRowData } from 'components/DataTable/Types';

import { useFieldId } from '../hooks/useFieldId';
import { useIsHighlighted } from './hooks/useIsHighlighted';

export const BodyCell = (props: CellContext<WebEDIRowData, unknown>) => {
  const {
    rowWithEmbeddedTableRowInfo,
    cell: { id },
    column,
    row,
    table,
  } = props;
  const { columnDef } = column;
  const tableMeta = table.options.meta;
  const columnMeta = columnDef.meta;

  if (!table.options.meta?.mode) {
    logError(new GenericError('Table display mode is missing', { tableMeta }));
  }
  const displayMode = (table.options.meta?.mode || DisplayModes.view) as DisplayModes;
  const fieldId = useFieldId(id, column, tableMeta?.dataPrefix, rowWithEmbeddedTableRowInfo, row, displayMode);
  const isHighlighted = useIsHighlighted(row, column, displayMode, table);

  if (!columnMeta) {
    logError(new GenericError('Column meta is missing', { columnDef }));
    return null;
  }
  const [ViewComponent, EditComponent] = cellMapping[columnMeta.type as ui.FieldTypes];

  if (!ViewComponent || !EditComponent) {
    logError(new GenericError('Cell component not found', { type: columnMeta.type }));
    return null;
  }

  const Cell = displayMode === DisplayModes.view ? ViewComponent : EditComponent;

  return <Cell {...props} isHighlighted={isHighlighted} fieldId={fieldId} key={fieldId} mode={displayMode} />;
};
